import { currencyFormat } from 'common/helpers/numberHelper';

const ShipPrice = (props) => {
  const { shipping, settings } = props;
  if (shipping.originalPrice > shipping.price) {
    return (
      <div className="c7-cart-items__price">
        <span>{currencyFormat(shipping.originalPrice, settings)}</span>
        <br />
        {currencyFormat(shipping.price, settings)}
      </div>
    );
  }
  return (
    <div className="c7-cart-items__price">
      {currencyFormat(shipping.price, settings)}
    </div>
  );
};

export default ShipPrice;
